// PortalSubscriptionModal - Payment integrations discontinued
// Stub component to prevent build errors

interface PortalSubscriptionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PortalSubscriptionModal({ open, onOpenChange }: PortalSubscriptionModalProps) {
  // Payment integrations discontinued - redirect to contact
  return null;
}
